import ReactGA from "react-ga4";

export const initializeGA = () => {
    console.log("Analytics Initialized");
    ReactGA.initialize("G-R0R6V472C0"); // Replace with your GA4 Measurement ID
};
